import { useUserData } from './useUserData';
import { GetMe_me_organizations, GetMe_me_organizations_workspaces } from '../models/legacy-graphql';
import { useContext, useMemo } from 'react';
import { AppContext } from '../providers/AppProvider';

export type SelectedOrganization = {
  selectedOrganization: null | GetMe_me_organizations;
  selectedWorkspace: null | GetMe_me_organizations_workspaces;
};

export const useSelectedOrganization = (): SelectedOrganization => {
  const { selectedWorkspaceId } = useContext(AppContext);
  const { userData } = useUserData();

  return useMemo(() => {
    const selected: SelectedOrganization = { selectedOrganization: null, selectedWorkspace: null };

    if (userData && selectedWorkspaceId) {
      userData.organizations.forEach(org => {
        org.workspaces.forEach(workspace => {
          if (workspace.id === selectedWorkspaceId) {
            selected.selectedOrganization = org;
            selected.selectedWorkspace = workspace;
          }
        });
      });
    }
    return selected;
  }, [selectedWorkspaceId, userData]);
};
